module.exports = __webpack_public_path__ + "static/media/1f382.496cd7d4.svg";